import crypto from 'crypto';
import actions from './actions';

const tid = function generateTemporaryId() {
  const now = Date.now().toString() + Math.random();
  const tid = crypto
    .createHash('md5')
    .update(now)
    .digest('hex')
    .toString();
  return tid;
};

const toGrid = function roundToGridSize(value, size = 0) {
  if (size === 0) {
    size = grid_size;
  }
  return Math.round(value / size) * size;
};

const grid_size = 20;

class Block {
  constructor(type, action_type, { left, top, width, height }, action_id = 0) {
    this.type = type; // Форма
    this.exists = action_id != 0;
    this.action_id = this.exists ? action_id : tid();
    this.action_type = action_type; // Цвет
    this.id = `${type}-${this.action_id}`;
    this.title = '';
    this.left = left;
    this.top = top;
    this.width = width;
    this.height = height;
    this.slots = [0, 0, 0, 0];
    this.selected = false;
  }
}

class Action extends Block {
  constructor(action_type, { left, top, width, height }, action_id = 0) {
    super('act', action_type, {
      left: toGrid(left),
      top: toGrid(top),
      width: toGrid(width),
      height: toGrid(height),
    }, action_id);
    this.gateway = null;
    this.errors = false;
    this.hasJumps = false;
    this.unloadId = null;
  }

  makeGateway(constraints) {
    if (!this.gateway) {
      this.gateway = new Gateway(this.action_type, constraints, this.action_id);
    }
    return this.gateway;
  }
}

class Gateway extends Block {
  constructor(action_type, { left, top, width, height }, action_id = 0) {
    super('gateway', action_type, {
      left: toGrid(left, grid_size / 2),
      top: toGrid(top, grid_size / 2),
      width: toGrid(width),
      height: toGrid(height),
    }, action_id);
  }
}

const actionBlock = function makeExistsActionBlock({ id, tid, type, constraints, title, errors, unload_id }) {
  const act = new Action(type, constraints, id ? id : tid);
  act.title = title;
  act.errors = errors;
  act.unloadId = unload_id;
  return act;
};

const validateAction = function validateAction(action, options = {}, hasSegmentTrash = null) {
  let queue_id = null;
  let bot_script_id = null;
  let ats_group_id = null;
  let last_status = null;
  let how_call = null;
  let steps1 = null;
  let options_field = null;
  let bpm_bp_id = null;
  let bpm_db_key = null;
  let promo_codes = null;
  let delay = null;
  let split0 = null;
  let sending_sms_value = null;
  let email_templates = null;
  let push_template_ids = null;
  let on_site_template_ids = null;
  let appId = null;
  let expiration_valid = null;
  let channels = null;
  let split_sum = 0;
  let event_signal_id = null;
  let event_signal_name = null;
  let custom_integration_id = null;
  let write_from_field = null;
  let llm_model = null;
  let ai_assistant_options = null;
  let user_id_field = null;
  let order_field_target = null;
  let order_field_template = null;
  let telegram_identifiers = null;

  switch (action.type) {
    case 'segment_trash':
    case 'segment':

      break;
    case 'bot_incall':
      bot_script_id = _.isInteger(Number(action.bot_script_id)) && Number(action.bot_script_id) > 0;
    // eslint-disable-next-line no-fallthrough
    case 'in':
      bpm_db_key = _.isString(options.bpm_db_key) && options.bpm_db_key.length > 0;
    // eslint-disable-next-line no-fallthrough
    case 'queue':
      if (_.isObject(action.queue)) {
        ats_group_id = _.isInteger(Number(action.queue.ats_group_id)) && Number(action.queue.ats_group_id) > 0;
        if (action.type === 'queue') {
          last_status = _.isInteger(Number(action.queue.last_status)) && Number(action.queue.last_status) > 0;
          how_call = !_.isNull(action.queue.how_call) && _.isInteger(Number(action.queue.how_call)) >= 0;
          try {
            steps1 = Boolean(_.size(JSON.parse(action.queue.steps1)));
          } catch (e) {
            steps1 = false;
          }
        }
      } else {
        queue_id = _.isInteger(Number(action.queue_id)) && Number(action.queue_id) > 0;
      }
      break;
    case 'callbot':
    case 'chatbot':
    case 'in_chatbot':
      bot_script_id = _.isInteger(Number(action.bot_script_id)) && Number(action.bot_script_id) > 0;
      if (_.isObject(action.queue)) {
        ats_group_id = _.isInteger(Number(action.queue.ats_group_id)) && Number(action.queue.ats_group_id) > 0;
        if (action.type === 'chatbot') {
          ats_group_id = null;
        } else if (action.type === 'callbot') {
          last_status = _.isInteger(Number(action.queue.last_status)) && Number(action.queue.last_status) > 0;
          how_call = !_.isNull(action.queue.how_call) && _.isInteger(Number(action.queue.how_call)) >= 0;
          try {
            steps1 = Boolean(_.size(JSON.parse(action.queue.steps1)));
          } catch (e) {
            steps1 = false;
          }
        }
      } else {
        queue_id = _.isInteger(Number(action.queue_id)) && Number(action.queue_id) > 0;
      }
      if (action.type === 'in_chatbot') {
        bpm_db_key = _.isString(options.bpm_db_key) && options.bpm_db_key.length > 0;
        promo_codes = _.isArray(action.promo_codes) && action.promo_codes.length > 0;
      }
      if (action.type === 'chatbot') {
        channels = options && _.isArray(options.channels) && options.channels.length > 0;
        // Валидация telegram_identifiers: массив, каждый элемент содержит
        // field (строка, валидная по регулярке) и type (один из: 'username', 'chat_id')
        if (options && _.isArray(options.telegram_identifiers)) {
          telegram_identifiers = options.telegram_identifiers.every((identifier) => identifier
              && _.isString(identifier.field)
              && identifier.field.length >= 1
              && identifier.field.length <= 50
              && /^[a-zA-Z0-9_]+$/.test(identifier.field)
              && _.isString(identifier.type)
              && (
                identifier.type === 'username'
          // || identifier.type === 'chat_id'
              ));
        } else {
          // Если поле отсутствует или не массив, считаем валидным (опциональное поле)
          telegram_identifiers = null;
        }
      }
      break;
    case 'transfer':
      bpm_bp_id = _.isInteger(Number(options.bpm_bp_id)) && Number(options.bpm_bp_id) > 0;
      delay = _.isInteger(Number(options.delay)) && Number(options.delay) >= 0 && options.delay !== '';
      break;
    case 'split':
      if (action.jumps.length > 0) {
        let numTrash = 0;
        // если есть действие Корзина, то исключаем из подсчета
        if (hasSegmentTrash) {
          numTrash = 1;
        }
        options_field = _.isArray(options) && options.length === (action.jumps.length - numTrash);
      }
      if (_.isArray(options)) {
        _.each(options, (opt) => split_sum += opt.percent);
      }
      split0 = split_sum === 100;
      break;
    case 'sms_template':
      sending_sms_value = Array.isArray(options.sending_sms_value) && options.sending_sms_value.length > 0;
      break;
    case 'dmn':
      let regex = /^[a-zA-Z0-9_.-]+$/;

      if (options?.customWriteFromField) {
        // допустимые символы для произвольного значения:
        // буквы(латиница, кириллица, иероглифы и т.д.), цифры, пробелы, точки, подчеркивания, дефисы
        regex = /^[\p{L}\d\s._-]+$/u;
      }

      write_from_field = regex.test(options.writeFromField);
      break;
    case 'email_template':
      email_templates = Array.isArray(options.email_templates) && options.email_templates.length > 0;
      break;
    case 'push_template':
      push_template_ids = Array.isArray(options.push_template_ids) && options.push_template_ids.length > 0;
      break;
    case 'event_finish':
      if(Number(options.sub_type) == 1){
        event_signal_id = _.isInteger(Number(options.event_signal_id)) && Number(options.event_signal_id) > 0;
      } else if (Number(options.sub_type) == 3) {
        event_signal_name = _.has(options, 'name') && Boolean(options.name) && /^[A-z0-9_-]+$/.test(options.name);
      }
      break;
    case 'custom_request':
      custom_integration_id = options
        && _.isInteger(Number(options.custom_integration_id))
        && Number(options.custom_integration_id) > 0
        && _.includes(['webhook', 'ftp'], options.integration_type);
      break;
    case 'llm_request':
      llm_model = options
        && _.isString(options.provider) && options.provider.length > 0
        && _.isInteger(Number(options.prompt_id)) && Number(options.prompt_id) > 0
        && _.isString(options.target_field) && options.target_field.length > 0
        && _.isInteger(Number(options.success_status_id)) && Number(options.success_status_id) > 0
        && _.isInteger(Number(options.failure_status_id)) && Number(options.failure_status_id) > 0;
      break;
    case 'ai_assistant':
      ai_assistant_options = options
        && _.isString(options.assistant_config_id)
        && options.assistant_config_id.length > 0
        && _.isString(options.task)
        && options.task.trim().length > 0
        && (
          _.isUndefined(options.target_field)
          || _.isNull(options.target_field)
          || _.isString(options.target_field)
        )
        && (
          _.isUndefined(options.success_status_id)
          || _.isNull(options.success_status_id)
          || (_.isInteger(Number(options.success_status_id)) && Number(options.success_status_id) > 0)
        )
        && (
          _.isUndefined(options.failure_status_id)
          || _.isNull(options.failure_status_id)
          || (_.isInteger(Number(options.failure_status_id)) && Number(options.failure_status_id) > 0)
        );
      break;
    case 'order_field_update':
      order_field_target = _.isString(options.target_field)
        && options.target_field.length > 0
        && options.target_field.length <= 255;
      order_field_template = _.isString(options.value_template)
        && options.value_template.length > 0;
      break;
  }

  const states = {
    title: _.isString(action.title) && action.title.length > 0 && action.title.length <= 256,
    type: _.isString(action.type) && actions.hasOwnProperty(action.type),
    queue_id,
    bot_script_id,
    ats_group_id,
    last_status,
    how_call,
    steps1,
    options: options_field,
    split0,
    bpm_bp_id,
    bpm_db_key,
    delay,
    sending_sms_value,
    email_templates,
    push_template_ids,
    event_signal_id,
    event_signal_name,
    promo_codes,
    channels,
    custom_integration_id,
    write_from_field,
    llm_model,
    ai_assistant_options,
    order_field_target,
    order_field_template,
    user_id_field,
    telegram_identifiers,
    error: null,
  };

  for (let field in states) {
    if (states.hasOwnProperty(field) && states[field] === false) {
      states.error = field;
      return states;
    }
  }

  return states;
}

export {
  actionBlock,
  tid,
  validateAction,
};
